const {
  SupportedLangs,
  DefaultLang,
  LangLocaleMap,
  LocaleLangMap,
  HrefLang,
} = require('./constants');

const getLangByLocale = locale => {
  return LocaleLangMap[locale];
};

const getLangBySlug = slug => {
  const match = slug.match(new RegExp(`^\\/(${SupportedLangs.join('|')})(.*)`));
  return match === null ? DefaultLang : match[1];
};

const getLocaleBySlug = slug => {
  return LangLocaleMap[getLangBySlug(slug)];
};

const getPageName = slug => {
  const match = slug.match(new RegExp(`^\\/(${SupportedLangs.join('|')})(.*)`));
  return match === null ? slug : match[2];
};

const getHrefLangByLang = lang => {
  return HrefLang[lang];
};

const getHrefLangByLocale = locale => {
  return getHrefLangByLang(getLangByLocale(locale));
};

const renderPath = (pageName, lang) => {
  if (typeof lang === 'object') {
    const { lang: _lang, locale } = lang;
    if (_lang !== undefined) {
      return renderPath(pageName, _lang);
    }
    if (locale !== undefined) {
      return renderPath(pageName, LocaleLangMap[locale]);
    }
    throw new Error('should pass lang or locale property to the options');
  }
  return lang === DefaultLang ? pageName : `/${lang}${pageName}`;
};

module.exports = {
  getLangBySlug,
  getLocaleBySlug,
  getPageName,
  renderPath,
  getHrefLangByLocale,
  getHrefLangByLang,
  getLangByLocale,
};
